<template>
    <facility-landing-buttons />
</template>

<script setup lang="ts">
import { definePageMeta } from '#imports'
import FacilityLandingButtons from '~/components/Layouts/FacilityLandingButtons.vue'

definePageMeta({
    // The shared policy allows this public landing content only when embedded.
    searchIndexing: 'public',
    layout: 'org'
})
</script>
